import { withSize } from "react-sizeme";

export const withSizeHOC = withSize({ monitorHeight: true, monitorWidth: true });
